import React from "react";
import "./ice.css";

export default function UserCarousel({ users, currentIndex, onSelectIndex }) {
	const total = users.length;
	const maxVisible = 7;

	// Sliding window: keep currentIndex visible, show 7 at a time
	let windowStart = Math.max(0, currentIndex - maxVisible + 1);
	windowStart = Math.min(windowStart, Math.max(0, total - maxVisible));
	const visibleUsers = users.slice(windowStart, windowStart + maxVisible);

	const hiddenBefore = windowStart;
	const hiddenAfter = Math.max(0, total - (windowStart + maxVisible));

	return (
		<div className="d-flex justify-content-center align-items-center p-2 overflow-hidden">
			{hiddenBefore > 0 && (
				<div
					className="user-circle d-flex align-items-center justify-content-center fw-bold"
					style={{ cursor: "pointer", fontSize: "0.8rem" }}
					onClick={() => onSelectIndex(windowStart - 1)}
				>
					+{hiddenBefore}
				</div>
			)}
			{visibleUsers.map((user, idx) => {
				const absoluteIndex = windowStart + idx;
				return (
					<img
						key={user.uid}
						src={user.photoURL || "/images/no-profile-picture.png"}
						alt={user.displayName}
						className={`user-circle ${absoluteIndex === currentIndex ? "active" : ""}`}
						onClick={() => onSelectIndex(absoluteIndex)}
					/>
				);
			})}
			{hiddenAfter > 0 && (
				<div
					className="user-circle d-flex align-items-center justify-content-center fw-bold"
					style={{ cursor: "pointer", fontSize: "0.8rem" }}
					onClick={() => onSelectIndex(windowStart + maxVisible)}
				>
					+{hiddenAfter}
				</div>
			)}
		</div>
	);
}
